
(function() {
  var result = { translations: { "zh-hk": { "i18n": { "duration": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206\u9418", "hours": "{{ hours }} \u5C0F\u6642", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206\u9418", "days": "{{ days }} \u65E5", "shortForm": { "seconds": "{{ seconds }} \u79D2", "minutes": "{{ minutes }} \u5206", "hours": "{{ hours }} \u5C0F\u6642", "days": "{{ days }} \u65E5", "hoursAndMinutes": "{{ hours }} \u5C0F\u6642 {{ minutes }} \u5206" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} \u5E74\u7B2C {{quarterNumber}} \u5B63 " }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "zh-hk": "static-7.1303"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1303",
    "ar-eg": "static-7.1303",
    "bg": "static-7.1303",
    "bn": "static-7.1303",
    "ca-es": "static-7.1303",
    "cs": "static-7.1303",
    "da": "static-7.1303",
    "de": "static-7.1303",
    "el": "static-7.1303",
    "en-gb": "static-7.1303",
    "en": "static-7.1303",
    "es-mx": "static-7.1303",
    "es": "static-7.1303",
    "et": "static-7.1303",
    "fi": "static-7.1303",
    "fr-ca": "static-7.1303",
    "fr": "static-7.1303",
    "he-il": "static-7.1303",
    "hi": "static-7.1303",
    "hr": "static-7.1303",
    "hu": "static-7.1303",
    "id": "static-7.1303",
    "it": "static-7.1303",
    "ja": "static-7.1303",
    "ko": "static-7.1303",
    "lt": "static-7.1303",
    "ms": "static-7.1303",
    "nl": "static-7.1303",
    "no": "static-7.1303",
    "pl": "static-7.1303",
    "pt-br": "static-7.1303",
    "pt-pt": "static-7.1303",
    "ro": "static-7.1303",
    "ru": "static-7.1303",
    "sk": "static-7.1303",
    "sl": "static-7.1303",
    "sv": "static-7.1303",
    "th": "static-7.1303",
    "tl": "static-7.1303",
    "tr": "static-7.1303",
    "uk": "static-7.1303",
    "vi": "static-7.1303",
    "x-pseudo": "static-7.1303",
    "zh-cn": "static-7.1303",
    "zh-hk": "static-7.1303",
    "zh-tw": "static-7.1303"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:zh-hk', {version: 'static-7.1303'}); }
})();


